export function clickable() {
  document.querySelectorAll('.js-clickable').forEach((el) => {
    el.style.cursor = 'pointer';
    const newLoc = el.querySelector('a').href;
    el.onclick = () => {
      window.location = newLoc;
    };
  });
}
